import { useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth.jsx';
import { ArrowRight, X, Sparkles } from './Icons.jsx';

export default function AuthModal({ open, onClose }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState({ state: 'idle', message: '' });

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setStatus({ state: 'loading', message: '' });
    try {
      await login({ email: email.trim(), password });
      setStatus({ state: 'idle', message: '' });
      onClose?.();
    } catch (err) {
      setStatus({ state: 'error', message: err.message || 'Could not sign in.' });
    }
  };

  return createPortal(
    <div style={backdrop} onClick={onClose}>
      <div className="mm-auth-card" style={card} onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} aria-label="Close" style={closeBtn}>
          <X width="16" height="16" />
        </button>
        <div className="mm-auth-kicker" style={kicker}>
          <Sparkles width="14" height="14" style={{ verticalAlign: 'middle', marginRight: 6 }} />
          Sign in to Medi
        </div>
        <h2 style={heading}>Welcome back</h2>
        <p style={subhead}>
          Sign in with your email and password to save your progress and pick up where
          you left off.
        </p>

        <form onSubmit={submit}>
          <label style={label}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
            autoComplete="email"
            placeholder="you@example.com"
            required
            style={input}
          />
          <label style={{ ...label, marginTop: 12, display: 'block' }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            placeholder="Your password"
            required
            style={input}
          />
          {status.state === 'error' && (
            <div className="mm-auth-error" style={errorBox}>{status.message}</div>
          )}
          <button
            type="submit"
            className="mm-auth-primary"
            disabled={!email || !password || status.state === 'loading'}
            style={primaryBtn}
          >
            {status.state === 'loading' ? 'Signing in…' : 'Sign in'}
            <ArrowRight width="16" height="16" />
          </button>
        </form>

        <div style={footerRow}>
          <Link to="/forgot-password" style={footerLink} onClick={onClose}>
            Forgot password?
          </Link>
          <Link to="/signup" style={{ ...footerLink, fontWeight: 700 }} onClick={onClose}>
            Create an account →
          </Link>
        </div>
      </div>
    </div>,
    document.body,
  );
}

const backdrop = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(8, 4, 22, 0.78)',
  backdropFilter: 'blur(6px)',
  display: 'grid',
  placeItems: 'center',
  zIndex: 9999,
  padding: 16,
};
const card = {
  position: 'relative',
  background: '#ffffff',
  borderRadius: 16,
  padding: '28px 30px',
  width: '100%',
  maxWidth: 440,
  boxShadow: '0 30px 80px rgba(20, 5, 60, 0.35)',
  color: '#1f1240',
};
const closeBtn = {
  position: 'absolute',
  top: 12,
  right: 12,
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  color: '#6b7280',
  padding: 6,
};
const kicker = {
  fontSize: 12,
  fontWeight: 700,
  color: '#5b21b6',
  textTransform: 'uppercase',
  letterSpacing: '0.12em',
  marginBottom: 8,
};
const heading = {
  margin: '0 0 6px',
  fontSize: 22,
  color: '#1f1240',
  fontWeight: 700,
};
const subhead = {
  margin: '0 0 18px',
  color: '#4b4361',
  fontSize: 14.5,
  lineHeight: 1.55,
};
const label = {
  fontSize: 13,
  fontWeight: 600,
  color: '#3f3a5e',
};
const input = {
  width: '100%',
  padding: '12px 14px',
  fontSize: 15,
  border: '1px solid #d8d6e6',
  borderRadius: 10,
  marginTop: 6,
  outline: 'none',
  color: '#1f1240',
  background: '#ffffff',
  boxSizing: 'border-box',
};
const errorBox = {
  marginTop: 12,
  padding: '10px 14px',
  background: '#fee2e2',
  color: '#991b1b',
  borderRadius: 8,
  fontSize: 13,
};
const primaryBtn = {
  width: '100%',
  marginTop: 16,
  padding: '12px 16px',
  borderRadius: 10,
  border: 'none',
  background: 'linear-gradient(135deg, #5b21b6, #7c3aed)',
  color: '#ffffff',
  fontSize: 14.5,
  fontWeight: 700,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
};
const footerRow = {
  marginTop: 16,
  fontSize: 13.5,
  display: 'flex',
  justifyContent: 'space-between',
};
const footerLink = {
  color: '#5b21b6',
  textDecoration: 'none',
};
